import { all, call } from 'redux-saga/effects';

import { watchUserAuthSagas } from './authStatus/sagas';
import { watchLeadsBenchmarkGeneralSagas } from './general/sagas';
import { watchTimeDivisionChange } from './timeDivision/sagas';
// import { watchActionsForBenchmarking } from './benchmark/sagas';

export function* watchLeadsBenchmarkSagas() {
  yield all([
    call(watchUserAuthSagas),
    call(watchTimeDivisionChange),
    call(watchLeadsBenchmarkGeneralSagas),
    // call(watchActionsForBenchmarking)
  ]);
}
